// import localStorage from '@/utils/local-storage';
import Vue from 'vue';

const state = {
  type: localStorage ? localStorage.getItem('internationalType') || 'China' : 'China',
  domains: [],
  currentDomain: localStorage ? localStorage.getItem('internationalDomain') || 'geely' : 'geely'
};

const mutations = {
  UPDATE_VALUE(state, payload) {
    state.type = payload;
  },
  UPDATE_DOMAIN(state, payload) {
    state.domains = payload;
  },
  UPDATE_CURRENT_DOMAIN(state, payload) {
    state.currentDomain = payload;
  }
};

const actions = {
  queryDomains({ commit }) {
    return new Promise((resolve) => {
      Vue.api.fetchDomains().then(({ data }) => {
        commit('UPDATE_DOMAIN', data.map((item) => {
          return {
              ...item,
              label: item.loginExplain,
              value: item.tenantActiveDirectoryId
          };
        }));
        resolve();
      }).catch(resolve);
    });
  },
  updateInternational({ commit }, data) {
    return new Promise((resolve) => {
      localStorage && localStorage.setItem('internationalType', data);
      commit('UPDATE_VALUE', data);
      resolve();
    });
  },
  updateInternationalCurrentDomain({ commit }, data) {
    return new Promise((resolve) => {
      localStorage && localStorage.setItem('internationalDomain', data);
      commit('UPDATE_CURRENT_DOMAIN', data);
      resolve();
    });
  }
};

const getters = {
  international() {
    return state.type;
  },
  domains() {
    return state.domains;
  },
  internationalDomain () {
    return state.currentDomain;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
